import { bindable, BindingMode } from 'aurelia';

export class DestinationFilter {

    @bindable({ mode: BindingMode.twoWay }) selected = [];
    @bindable options;
    /**
     * {
     *      country: {
     *          text: string,
     *          value: string
     *      },
     *      resorts: {
     *          text: string,
     *          value: string
     *      }[]
     * }[]
    */
    @bindable class = "";
    default = [];
    isMobile = false;
    mediaQuery = null;
    
    RESOURCE_BASE_URL = aurelia_options.resourceBaseUrl;
    aurelia_options = aurelia_options;

    constructor() { }

    binding() {
        this.default = JSON.parse(JSON.stringify(this.selected));
    }

    attached() {
        this.mediaQuery = window.matchMedia('(min-width: 900px)');
        this.isMobile = !this.mediaQuery.matches;
        this.mediaQuery.addEventListener('change', this.onMatchMediaChange);
    }

    detached() {
        this.mediaQuery.removeEventListener('change', this.onMatchMediaChange);
    }

    onMatchMediaChange = (e) => {
        this.isMobile = !e.matches;
    };

    resetFilter() {
        this.selected = this.default;
    }

    openCloseFilter() {
        document.querySelector('#destination-selection-dropdown')?.dispatchEvent(new CustomEvent('e-toggle'));
    }
}
